module.exports = __webpack_public_path__ + "static/media/page05_man_boy.1aec2862.gif";